import { consumer, core } from '@tock/coretypes';
import { getBusinessPossessiveName } from 'utils/businessUtils';
import Anchor from 'components/Anchor';
import FaqLink from 'components/business/landing-page/FaqLink';

interface Props {
  businessConfig?: consumer.IBusinessConfig;
  selectedExperience?: core.ITicketType;
  isTableside?: boolean;
}

const WWW_URL = `https://www.exploretock.com`;

const TermsLabel: React.FunctionComponent<Props> = ({
  businessConfig,
  selectedExperience,
  isTableside,
}) => {
  const privacyUrl = `${WWW_URL}/privacy`;
  const termsUrl = `${WWW_URL}/terms`;

  const possessiveBusinessName = getBusinessPossessiveName(businessConfig?.name ?? '');

  const reservationType =
    selectedExperience?.variety === 'ORDER_DELIVERY' ||
    selectedExperience?.variety === 'ORDER_PICKUP' ||
    isTableside
      ? 'order'
      : 'reservation';

  const getFaqText = () => {
    if (businessConfig?.showFaq) {
      return (
        <span style={{ display: 'inline-flex' }}>
          Have additional questions? Review {possessiveBusinessName}&nbsp;
          <FaqLink underlined>FAQs</FaqLink>.
        </span>
      );
    } else {
      return undefined;
    }
  };

  const commonTerms = (
    <>
      By completing your {reservationType}, you acknowledge that you have read{' '}
      {possessiveBusinessName}
      cancellation policy, and agree to Tock's{' '}
      <Anchor href={termsUrl} target="_blank" className="u-activeColor">
        Terms of Use
      </Anchor>{' '}
    </>
  );

  return (
    <span>
      {commonTerms}and{' '}
      <Anchor href={privacyUrl} target="_blank" className="u-activeColor">
        Privacy Policy.
      </Anchor>{' '}
      Standard text message and data rates may apply. You can opt out of receiving messages at any
      time by texting "END". {getFaqText()}
    </span>
  );
};

export default TermsLabel;
